import axios from 'axios';

export const getChatList = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + "/api/v1/users/chatList",
            params: values,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err)
        })
    })
}

export const getChannel = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + "/api/v1/users/chatList",
            data: values,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err)
        })
    })
}